import { DEFAULT_INPUT_INDICATOR_LABELS } from "../indicator/labels.js";
import { deriveVolumeStatus } from "../volume-indicator/status.js";
//#region src/core/ui/status-indicator/status.ts
/**
* Derives the predicted visual status from an input action and its pre-action media snapshot.
*
* @internal
*/
function deriveStatus(event, snapshot, labels = DEFAULT_INPUT_INDICATOR_LABELS) {
	switch (event.action) {
		case "togglePaused": {
			const paused = snapshot.paused !== void 0 ? !snapshot.paused : true;
			return {
				status: paused ? "pause" : "play",
				label: paused ? labels.paused : labels.playing,
				value: null
			};
		}
		case "toggleMuted":
		case "volumeStep": return deriveVolumeStatus(event, snapshot, labels);
		case "toggleSubtitles": {
			if (snapshot.subtitlesAvailable === false) return null;
			const showing = snapshot.subtitlesShowing !== void 0 ? !snapshot.subtitlesShowing : true;
			return {
				status: showing ? "captions-on" : "captions-off",
				label: showing ? labels.captionsOn : labels.captionsOff,
				value: null
			};
		}
		case "toggleFullscreen": {
			const fullscreen = snapshot.isFullscreen !== void 0 ? !snapshot.isFullscreen : true;
			return {
				status: fullscreen ? "fullscreen" : "exit-fullscreen",
				label: fullscreen ? labels.fullscreen : labels.exitFullscreen,
				value: null
			};
		}
		case "togglePictureInPicture": {
			const pip = snapshot.isPictureInPicture !== void 0 ? !snapshot.isPictureInPicture : true;
			return {
				status: pip ? "pip" : "exit-pip",
				label: pip ? labels.pictureInPicture : labels.exitPictureInPicture,
				value: null
			};
		}
		default: return null;
	}
}
/**
* Returns the volume percentage when present, then the translated status label.
*
* @internal
*/
function getStatusIndicatorDisplayValue(state) {
	return state.value ?? state.label ?? "";
}
//#endregion
export { deriveStatus, getStatusIndicatorDisplayValue };
